<template>
  <div id='RuleTemplateList'>
    <eb-header>
      <eb-break-crumb slot='breakCrumb' />
      <eb-search @search-click='loadRuleTemplateDataBySearchWord' slot='search' />
    </eb-header>
    <div class="box-header">
      <div class="box-header-right">
        <el-button class='el-button eb-button-red eb-button-small' @click='goTplPreview'>查看</el-button>
        <el-button v-show='btnshow' class='el-button eb-button-red eb-button-small' @click='showAddTplWindow'>新增</el-button>
        <el-button v-show='btnshow' :disabled='!isCanEdit' @click='editTplRuleDigital' class='el-button eb-button-red eb-button-small'> 编辑规则</el-button>
        <el-button v-show='btnshow' @click='showCopyTplWindow' class='el-button eb-button-red eb-button-small'>复制</el-button>
        <el-button v-show='btnshow' :disabled='!isCanDelete' @click='deleteTpl' class='el-button eb-button-red eb-button-small'>删除</el-button>
      </div>
    </div>
    <div class="table-box">
      <div class='eb-table'>
        <el-table :data='pageData.ruleTemplateList' :stripe='true' @current-change='handleCurrentRowChange'>
          <el-table-column label='选中' width='55'>
            <template slot-scope='scope'>
              <el-radio class='radio' v-model='radioValue' :label='scope.$index'>&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column property='templateCode' label='模板编号' width='100'></el-table-column>
          <el-table-column property='templateName' label='模板名称'></el-table-column>
          <el-table-column property='templateMemo' label='模板备注' width='120'></el-table-column>
          <el-table-column property='userName' label='所属用户' width='120'></el-table-column>
          <el-table-column property='orgName' label='所属机构' width='100'></el-table-column>
          <!-- <el-table-column property='isRemove' label='是否删除' style='display:none;'>
        <template slot-scope='scope'>
          {{scope.row.isRemove|yesOrNo}}
        </template>
      </el-table-column> -->
          <el-table-column property='publicState' label='公开状态' width='80'>
            <template slot-scope='scope'>
              {{scope.row.publicState|publicState}}
            </template>
          </el-table-column>
          <el-table-column property='createUserName' label='创建人' width='80'></el-table-column>
          <el-table-column label='创建时间' width='165'>
            <template slot-scope='scope'>
              {{scope.row.createTime|dateTimeStandardFormat}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <eb-pagination v-if='pageData.recordsTotal' @current-change='onPageChange' :current-page.sync='pageNumber' :total='pageData.recordsTotal'
    />
    <RuleTemplateEditDialog @ruleTmeplateSuccess="ruleTmeplateSuccess" :isVisible.sync='dialogVisible' :ruleTemplateInfo='ruleTemplateInfo'
    />
  </div>
</template>

<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebSearch from '@/components/common/eb-search';
import EbPagination from '@/components/common/eb-pagination/eb-pagination';
import RuleTemplateEditDialog from '@/components/ruletemplate/edit/RuleTemplateEditDialog';
import { listRuleTemplate, deleteRuleTemplateById } from '@/services/rule/rule-template-service';
import { clone, includes } from 'lodash';
import { checkIsAdminUser, checkIsBuyerUser, checkIsBuyerManageUser } from '@/services/user/user-service';
import { getOrgPrivs } from '@/services/priv/org-priv-service';

export default {
  components: {
    ebHeader,
    ebBreakCrumb,
    ebSearch,
    EbPagination,
    RuleTemplateEditDialog
  },
  data() {
    return {
      user: this.$store.state.user.userInfo,
      pageNumber: 1,
      initSearchParams: {
        length: 10,
        start: 1
      },
      searchParams: null,
      radioValue: null,
      pageData: {
        ruleTemplateList: [],
        recordsTotal: 0
      },
      currentSelectedRow: null,
      isCanEdit: false,
      isCanDelete: false,
      dialogVisible: false,
      btnshow: false,
      ruleTemplateInfo: {
        dialogVisible: false,
        operType: 'add',
        isCanEditTplName: true,
        templateId: null,
        templateCode: null,
        templateName: null,
        templateMemo: null,
        publicState: null
      },
      defRuleTemplateNameArr: [
        '全网基础模板',
        '全网询价模板',
        '全网招标模板',
        '全网竞价模板',
        '机构默认询价模板',
        '机构默认招标模板',
        '机构默认竞价模板'
      ]
    };
  },
  computed: {
    paginationSize() {
      return this.pageData.recordsTotal / this.searchParams.length;
    }
  },
  created() {
    this.searchParams = clone(this.initSearchParams);
    this.loadRuleTemplateData();
    this.getOrgPrivs();
  },
  methods: {
    // 搜索操作
    loadRuleTemplateDataBySearchWord(text) {
      this.searchParams.searchWord = text;
      this.loadRuleTemplateData();
    },
    // 当前页改变操作
    onPageChange(pageNum) {
      this.searchParams.start = pageNum;
      this.loadRuleTemplateData();
    },
    async loadRuleTemplateData() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await listRuleTemplate(this.searchParams);
        this.pageData.recordsTotal = data.recordsTotal;
        this.pageData.ruleTemplateList = data.data;
      } catch (error) {
        this.$message.error('加载规则模板列表失败');
      }
      this.$root.layout.isLoading = false;
    },
    // 编辑按钮是否显示
    checkIsCanEdit(orgId, userId) {
      if (checkIsAdminUser(this.user.roleid + '')) {
        return true;
      } else if (checkIsBuyerUser(this.user.roleid + '')) {
        return userId + '' === this.user.userid;
      } else if (checkIsBuyerManageUser(this.user.roleid + '')) {
        return orgId + '' === this.user.orgId;
      } else {
        return false;
      }
    },
    // 删除按钮是否显示
    checkIsCanDelete(templateName, orgId, userId) {
      return this.checkIsCanEdit(orgId, userId) && !includes(this.defRuleTemplateNameArr, templateName);
    },
    // 当前选中行改变操作
    handleCurrentRowChange(currRow) {
      this.radioValue = this.pageData.ruleTemplateList.indexOf(currRow);
      this.currentSelectedRow = currRow;
      if (this.currentSelectedRow) {
        this.isCanEdit = this.checkIsCanEdit(this.currentSelectedRow.orgId, this.currentSelectedRow.userId);
        this.isCanDelete = this.checkIsCanDelete(
          this.currentSelectedRow.templateName,
          this.currentSelectedRow.orgId,
          this.currentSelectedRow.userId
        );
      }
    },
    // 查看
    goTplPreview() {
      if (!this.currentSelectedRow) {
        this.$message.warning('请选择一条数据进行操作');
      } else {
        window.open('/v2/rule/template/preview/' + this.currentSelectedRow.templateId);
      }
    },
    // 新增
    showAddTplWindow() {
      this.dialogVisible = true;
      this.ruleTemplateInfo.operType = 'add';
      this.ruleTemplateInfo.templateId = null;
      this.ruleTemplateInfo.templateName = null;
      this.ruleTemplateInfo.templateMemo = null;
      this.ruleTemplateInfo.publicState = null;
    },
    // 编辑规则
    editTplRuleDigital() {
      if (!this.currentSelectedRow) {
        this.$message.warning('请选择一条数据进行操作');
      } else {
        this.$router.push('/v2/rule/template/edit/' + this.currentSelectedRow.templateId);
      }
    },
    // 复制
    showCopyTplWindow() {
      if (!this.currentSelectedRow) {
        this.$message.warning('请选择一条数据进行操作');
      } else {
        this.ruleTemplateInfo.templateId = this.currentSelectedRow.templateId;
        this.ruleTemplateInfo.templateName = this.currentSelectedRow.templateName;
        this.ruleTemplateInfo.templateMemo = this.currentSelectedRow.templateMemo;
        this.ruleTemplateInfo.publicState = this.currentSelectedRow.publicState;
        this.ruleTemplateInfo.operType = 'copy';
        this.dialogVisible = true;
      }
    },
    // 删除
    deleteTpl() {
      if (!this.currentSelectedRow) {
        this.$message.warning('请选择要删除的规则模板');
      } else {
        this.$ebConfirm('确认要删除该模板吗?')
          .then(async result => {
            try {
              let { data } = await deleteRuleTemplateById(this.currentSelectedRow.templateId);
              if (data.returnCode === '01') {
                this.$message.success('删除规则模板成功');
                this.loadRuleTemplateData();
              } else if (data.returnCode === '03') {
                this.$message.error('参数不完整');
              } else {
                this.$message.error('删除规则模板失败');
              }
            } catch (err) {
              this.$message.error(err);
            }
          })
          .catch(() => {});
      }
    },
    ruleTmeplateSuccess: function() {
      this.loadRuleTemplateData();
    },
    // 是否有自定义模板的权限
    async getOrgPrivs() {
      try {
        let { data } = await getOrgPrivs(this.user.orgId);
        if (data.returnCode === '01') {
          if (checkIsAdminUser(this.user.roleid + '')) {
            this.btnshow = true;
          } else if (data.orgPrivs.length > 0) {
            let statusName = '';
            data.orgPrivs.forEach(n => {
              statusName = n.privStatusName;
            });
            if (statusName === '允许修改') {
              this.btnshow = true;
            } else {
              this.btnshow = false;
            }
          } else {
            this.btnshow = false;
          }
        } else {
          this.$message.error('获取机构权益模版失败');
        }
      } catch (err) {
        this.$message.error(err);
      }
    }
  }
};
</script>

<style  scoped lang='less'>
#RuleTemplateList {
  .button-box {
    display: flex;
    height: 60px;
    justify-content: flex-end;
    align-items: center;
    padding-right: 45px;
    padding-top: 20px;
  }
}
</style>
